module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James White, David Langford\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("James White")]), _vm._v(" lived in Northern Ireland. He was a popular writer of science fiction for over forty years. He died in 1999.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/68jijB/tc-custom/9781429982283.jpg?1724854657685",
      "alt": "This image is the cover for the book Alien Emergencies, The Sector General Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Alien Emergencies, The Sector General Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The second three volumes of James White's Sector General SF saga, in a single omnibus edition.")]), _c('br'), _c('br'), _vm._v("Sector General: A vast hospital complex in the depths of outer space. The thousands who work there, human and alien both, have a single mission: To care for all patients, of all species. At Sector General, anything can happen-and frequently does."), _c('br'), _c('br'), _vm._v("James White's tales of Sector General are lively, humorous, and humane, at times shot through with a healer's anger at violence and destruction. These are endlessly inventive dramas of civility and spirituality, tempered with White's gently wicked wit and his keen eye for the remarkable in the everyday."), _c('br'), _c('br'), _vm._v("Now, in a single omnibus, the second three volumes of the series-Ambulance Ship, Sector General, "), _c('i', [_vm._v("and ")]), _vm._v("Star Healer-return to print in complete and corrected editions, including a sequence (\"Spacebird\") omitted from previous American editions of "), _c('i', [_vm._v("Ambulance Ship")]), _vm._v(". The volume is introduced by Hugo-winning SF writer and critic David Langford. "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0